import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { getColumnList } from '../../../selectors/declaration';

const getSelected = (selected, columns) => Object.keys(selected).length > 0
    ? selected
    : columns.reduce((res, column, index) => {
        if (column && column.mobile) {
            res[index] = true;
        }

        return res;
    }, {});


export const useEnrouteSetting = () => {
    const routesDeclaration = useSelector((state) => get(state, 'routesDeclaration', {}));
    const columns = useSelector(getColumnList);

    const [selected, changeSelected] = useState(getSelected(routesDeclaration.routesDeclaration || {}, columns));

    const selectedAll = useMemo(() => columns.length === Object.keys(selected).length, [columns, selected]);

    const handleRowSelection = useCallback(
        (index) =>
            changeSelected((oldState) => {
                const selected = {
                    ...oldState,
                };

                if (selected[index]) {
                    delete selected[index];
                } else {
                    selected[index] = true;
                }

                return selected;
            }),
        [selected]
    );

    const handleToggleAll = useCallback(() => {
        changeSelected(selectedAll ? {} : columns.reduce((res, column, index) => {
            res[index] = true;

            return res;
        }, {}));
    }, [selectedAll]);

    return {
        columns,
        selected,
        selectedAll,
        handleRowSelection,
        handleToggleAll
    };
};
